export default __webpack_public_path__ + "static/manager-a81595086cddcb69c2cef7d06f9b1adb.jpeg";